<script setup lang="ts">
defineProps<{
  title: string
}>()
</script>

<template>
  <div class="mb-8">
    <h3 class="mb-2 text-xs font-semibold uppercase tracking-[0.05em] text-gray-400">{{ title }}</h3>
    <slot />
  </div>
</template>
